import router from './routers'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
NProgress.configure({ showSpinner: false })// NProgress Configuration
import { device } from '@/utils/index'

router.beforeEach(async (to, from, next) => {
  if (!device.isMobile) {
    if(to.fullPath.indexOf('/m/') > -1) {
      const path = to.path.replace('/m', '');
      next({ path, query: to.query });
      return
    }
  }else{
    if(to.path.indexOf('/m/') < 0) {
      const path = '/m' + to.path;
      next({ path, query: to.query })
      return
    }
  }
  if(to.path === from.path && to.query.book_id !== from.query.book_id) {
    router.go(0)
    return
  }
  NProgress.start()
  next()
})
router.afterEach(() => {
  NProgress.done();
})
